import type { CSSProperties } from 'react';
import { cn } from '../lib/cn';

const SHIMMER: CSSProperties = {
  backgroundImage: 'linear-gradient(90deg, var(--ops-surface-2) 25%, #E9ECF3 37%, var(--ops-surface-2) 63%)',
  backgroundSize: '200% 100%',
};

export function SkeletonBar({ className }: { className?: string }) {
  return <div className={cn('rounded-ops-sm animate-ops-shimmer', className)} style={SHIMMER} />;
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={cn('rounded-ops-card border border-ops-border bg-ops-surface p-5 shadow-ops-card', className)}>
      <div className="flex items-center gap-3">
        <SkeletonBar className="h-10 w-10 !rounded-full" />
        <div className="flex-1 space-y-2">
          <SkeletonBar className="h-3.5 w-1/2" />
          <SkeletonBar className="h-3 w-1/3" />
        </div>
      </div>
      <div className="mt-5 space-y-2.5">
        <SkeletonBar className="h-3 w-full" />
        <SkeletonBar className="h-3 w-5/6" />
        <SkeletonBar className="h-3 w-2/3" />
      </div>
    </div>
  );
}
